import _get from 'lodash/get';

const defaultAkZipcode = {
    value: null,
    status: 'pending',
};

/* istanbul ignore next */
export const selectProductOffering = (state) => state.productOffering || {};
/* istanbul ignore next */
export const selectDeliveryDate = (state) => state.deliveryDate || {};
/* istanbul ignore next */
export const selectDeliveryZipcode = (state) => state.deliveryZipcode || '';
export const selectProductPricingFallBack = (state) => state.ProductPricingFallBack || {};
export const selectSignInSliderDetails = (state) => state.signInSliderDetails || {};
export const selectUserAkamaiZipcode = (state) => state.akZipcode || defaultAkZipcode;
export const selectUserSigninSuccess = (state) =>
    /* istanbul ignore next */
    state.signInSliderDetails ? !!state.signInSliderDetails.authenticationSuccess : false;
/* istanbul ignore next */
export const selectExternalStaticBasePath = (state) =>
    _get(state, 'context.staticRoutes.externalStaticBasePath', '');
/* istanbul ignore next */
export const selectUrgencyMessages = (state) => state.urgencyMessages || {};
